import React from 'react'
import {Row, Col,} from 'antd';
import MainWeb from '../cpn/MainWeb';
import {VideoCameraOutlined} from '@ant-design/icons';
function Home() { 
    return (
        <MainWeb>
            <Row>
                <Col span={6}></Col>
                <Col 
                    span={12} 
                    style={{
                        display:'flex',
                        flexDirection:"column"
                    }}
                >
                    <a 
                        style={{fontSize:'32px',lineHeight:'80px'}}
                        onClick={() => {
                            window.open('https://www.bilibili.com/video/BV1vnwSe8ERP/')
                        }}
                    ><VideoCameraOutlined /> 教程一：免费试用</a>
                    <a 
                        style={{fontSize:'32px',lineHeight:'80px'}}
                        onClick={() => {
                            window.open('https://www.bilibili.com/video/BV1RqAaeUEhG/?vd_source=64f29708c72584c764210a02d53e7778')
                        }}
                    ><VideoCameraOutlined /> 教程二：系统设置</a>
                    <a 
                        style={{fontSize:'32px',lineHeight:'80px'}}
                        onClick={() => {
                            window.open('https://www.bilibili.com/video/BV1yrPteWErg/?vd_source=64f29708c72584c764210a02d53e7778')
                        }}
                    ><VideoCameraOutlined /> 教程三：计调操作</a>
                    <img src='./img/home1.png' alt='' />
                    <img src='./img/home2.png' alt='' />
                    <img src='./img/home3.png' alt='' />
                    <img src='./img/home4.png' alt='' />
                    <img src='./img/home5.png' alt='' />
                    <img src='./img/home6.png' alt='' />
                    <img src='./img/home7.png' alt='' />
                    <img src='./img/home8.png' alt='' />
                    <img src='./img/home9.png' alt='' /> 
                </Col>
                <Col span={6}></Col>
            </Row>
            
        </MainWeb>
    )
}

export default Home